/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\SeenCar\SeenCar.service.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday December 21st 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Thursday December 21st 2023 4:32:32 pm
 * Modified By: the developer formerly known as Jonathan MAZAT at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import generalQueryParams from "Type/params.type";
import { FromRefTime, buildAxiosHeader, buildURL } from "Utils/Request.utils";
import Axios from "axios";

export default class SeenCarService {
    static async getAllView(params: generalQueryParams) {
        if (params.from)
            params.from = FromRefTime(params.from);
        const myUrl = buildURL(params,`${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.SEENCAR}`);
        const mySeenCars = await Axios.get(myUrl, buildAxiosHeader());
        return mySeenCars.data;
    };

    static totalViews() {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.SEENCAR}/count`;
        return Axios.get(url, buildAxiosHeader());
    }

};
